import { render, staticRenderFns } from "./PeoplePage.vue?vue&type=template&id=0f3669a7"
import script from "./PeoplePage.vue?vue&type=script&lang=ts"
export * from "./PeoplePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports